// extracted by mini-css-extract-plugin
module.exports = {"boxResetCategory":"ResetFilter_boxResetCategory__3eI-s","btnReset":"ResetFilter_btnReset__QqJwH"};